import { useEffect, useMemo } from "react";
import { ImagePlus, X } from "lucide-react";

export const MAX_PHOTOS = 5;

export const ThriftPhotos = ({ files, setFiles, disabled }) => {
  const previews = useMemo(() => files.map((f) => URL.createObjectURL(f)), [files]);
  useEffect(() => () => previews.forEach(URL.revokeObjectURL), [previews]);

  const add = (e) => {
    const picked = [...e.target.files].filter((f) => f.type.startsWith("image/"));
    setFiles((cur) => [...cur, ...picked].slice(0, MAX_PHOTOS));
    e.target.value = "";
  };

  return (
    <div className="grid grid-cols-5 gap-2" data-testid="thrift-upload-photos">
      {previews.map((src, i) => (
        <div key={src} className="relative aspect-square bg-[#F1EFEB]">
          <img src={src} alt={`Photo ${i + 1}`} className="h-full w-full object-cover" />
          {i === 0 && <span className="absolute bottom-0 inset-x-0 bg-[#0F0F0F]/70 text-white text-[8px] font-mono uppercase tracking-widest text-center py-0.5">Cover</span>}
          {!disabled && (
            <button type="button" data-testid={`thrift-upload-remove-photo-${i}`} aria-label="Remove photo" onClick={() => setFiles((cur) => cur.filter((_, j) => j !== i))} className="absolute top-1 right-1 h-5 w-5 rounded-full bg-white/90 flex items-center justify-center">
              <X className="h-3 w-3" />
            </button>
          )}
        </div>
      ))}
      {files.length < MAX_PHOTOS && (
        <label data-testid="thrift-upload-add-photo" className={`aspect-square border border-dashed border-[#C5A059]/60 flex flex-col items-center justify-center gap-1 text-[#B38F46] cursor-pointer hover:bg-[#C5A059]/5 transition-colors ${disabled ? "pointer-events-none opacity-50" : ""}`}>
          <ImagePlus className="h-5 w-5" strokeWidth={1.5} />
          <span className="font-mono text-[9px] uppercase tracking-widest">{files.length}/{MAX_PHOTOS}</span>
          <input data-testid="thrift-upload-photo-input" type="file" accept="image/*" multiple onChange={add} className="sr-only" />
        </label>
      )}
    </div>
  );
};
